import {
  ConfigurationStructure,
  ConfigurationStructureKey,
} from 'common/src/modules/configuration/configuration.types';

const cachedConfiguration: Partial<Record<keyof ConfigurationStructure, Promise<unknown>>> = {
  [ConfigurationStructureKey.GoogleSheetAccountEmail]: null,
  [ConfigurationStructureKey.BEBuildMetadata]: null,
};
export {cachedConfiguration};
